import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 18, viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.5 5L9.5 13L1.5 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
